const routes = [{
  path: '/broadcast', // 广播管理
  name: 'broadcast',
  component: () => import('@src/modules/broadcast/main'),
  meta: {
    requireAuth: true,

  },
  children: [{
      path: 'audio', // 广播管理-音频管理
      name: 'broadcastAudio',
      component: () => import('@src/modules/broadcast/view/audio'),
      meta: {
        requireAuth: true,
        routerAlive: true
      },
    },
    {
      path: 'call', // 广播管理-远程喊话
      name: 'broadcastCall',
      component: () => import('@src/modules/broadcast/view/call'),
      meta: {
        requireAuth: true,
        // routerAlive: true
      },
    },
    {
      path: 'linkage', // 广播管理-联动配置
      name: 'broadcastLinkage',
      component: () => import('@src/modules/broadcast/view/linkage'),
      meta: {
        requireAuth: true,
        routerAlive: true
      },
    }
  ],
}, ]

export default routes